module.exports = __webpack_public_path__ + "img/ai-9.ef187e1.png";